import React from 'react';
import { useIntl } from 'umi';

import { StatusTip } from 'tea-component';
import './index.scss'

export default function App(props: any) {
  const { formatMessage } = useIntl()
  const { marginTop = '0', content = formatMessage({ id: 'common_loading' }), classNameValue = '', style } = props;
  return (
    <div style={style} className={`box${classNameValue == '' ? '' : ' ' + classNameValue}`}>
      <StatusTip status="loading" loadingText={content} style={{ marginTop: marginTop }} />
    </div>
  );
}
